'use client';

import { CircularProgress } from '@jouzen/ecom-components/v3/CircularProgress';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { redirect } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { useCartContext } from '@/app/contexts/CartProvider';
import useDiscountPage from '@/app/hooks/useDiscountPage';

export interface DiscountPageProps {
  readonly handle: string | null | undefined;
}

const DiscountPage = ({ handle }: DiscountPageProps) => {
  const { handleSetUrlDiscountCode } = useCartContext();
  const { redirectUrl, isReady } = useDiscountPage(handle);
  const t = useTranslations();

  useEffect(() => {
    handleSetUrlDiscountCode(handle ?? '');
    if (isReady) {
      redirect(redirectUrl);
    }
  }, [handle, handleSetUrlDiscountCode, isReady, redirectUrl]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-sandstone-100 text-sandstone-500">
      <div className="flex items-center justify-center gap-4">
        <CircularProgress size={20} />
        <Typography>{t('loading')}</Typography>
      </div>
    </div>
  );
};

export default DiscountPage;
